import type { ProductOverlaysProps } from "../types/components/ProductOverlaysProps";
import Flame from "./../assets/images/fire-small.gif";

import "../assets/scss/components/_product-overlays.scss";
import Sale from "./../assets/images/shopping-discount-small.gif";
import { Image } from "./Image";

export const ProductOverlays = ({ type = "", value = "" }: ProductOverlaysProps) => {
	return type && value ? (
		<div className="overlays-container">
			<div className="overlays">
				<div className="overlay-track">
					{type === "sellingFast" && (
						<div className="selling-fast">
							<Image src={Flame} alt="Bonfire" width="16px" height="22px" />
							Selling Fast!
						</div>
					)}

					{type === "sale" && (
						<div className="sale">
							<Image src={Sale} alt="Sale icon" width="22px" height="22px" />
							{value.toFixed(0)}% Off!
						</div>
					)}
				</div>
			</div>
		</div>
	) : (
		<></>
	);
};
